import CustomNode from './CustomNode';


const nodeTypes = {
  custom: CustomNode,
}

export default nodeTypes;